import * as types from "../types/shift.types";
import {
  getSingleShift,
  getShiftsFiltersPagination,
  shiftActive,
  shiftInActive,
  getSingleShiftRiders,
  riderShiftRemove,
  RiderReAssignShift, getShiftTypes,
} from '../../services/shift.service';
import { validationErrors } from "../../utils/Helpers";

export const getSingleShiftAction = (data) => async (dispatch, getState) => {
  let request_status = false;
  let return_data = [];
  try {
    await getSingleShift(data, getState().authReducer.token, getState().authReducer.user.id).then((res) => {
      if(res.data.code === 200){
        dispatch({
          type: types.SET_SINGLE_SHIFT_DATA,
          payload: res.data.data,
        });
        request_status = true;
        return_data = res.data.data;
      }
    });
  } catch (e) {
    validationErrors(e);
  }
  if (request_status) return return_data;
  else return false;
};

export const getShiftsFiltersPaginationAction = (data, navigate) => async (dispatch, getState) => {
  let request_status = false;
  let return_data = [];
  try {
    await getShiftsFiltersPagination(data, getState().authReducer.token, getState().authReducer.user.id).then((res) => {
      if(res.data.code === 200){
        dispatch({
          type: types.SET_SHIFT_DATA,
          payload: res.data.data,
        });
        dispatch({
          type: types.SET_SHIFT_PAGINATION,
          payload: res.data.pagination,
        });
      }
    });
  } catch (e) {
    validationErrors(e);
  }
  if (request_status) return return_data;
  else return false;
};

export const shiftActiveAction = (data, navigate) => async (dispatch, getState) => {
  let request_status = false;
  let return_data = [];
  try {
    await shiftActive(data, getState().authReducer.token, getState().authReducer.user.id).then((res) => {
      // console.log('res.data: ',res.data);
      if(res.data.code === 200){
        // dispatch({
        //   type: types.SET_SHIFT_DATA,
        //   payload: res.data.data,
        // });
      }
    });
  } catch (e) {
    validationErrors(e);
  }
  if (request_status) return return_data;
  else return false;
};


export const shiftInActiveAction = (data, navigate) => async (dispatch, getState) => {
  let request_status = false;
  let return_data = [];
  try {
    await shiftInActive(data, getState().authReducer.token, getState().authReducer.user.id).then((res) => {
      if(res.data.code === 200){
        // dispatch({
        //   type: types.SET_SHIFT_DATA,
        //   payload: res.data.data,
        // });
      }
    });
  } catch (e) {
    validationErrors(e);
  }
  if (request_status) return return_data;
  else return false;
};

export const getSingleShiftRidersAction = (shiftId, data) => async (dispatch, getState) => {
  let request_status = false;
  let return_data = [];
  try {
    await getSingleShiftRiders(shiftId, data, getState().authReducer.token, getState().authReducer.user.id).then((res) => {
      if(res.data.code === 200){
        dispatch({
          type: types.SET_SINGLE_SHIFT_RIDER_DATA,
          payload: res.data.data,
        });
        dispatch({
          type: types.SET_SINGLE_SHIFT_RIDER_PAGINATION,
          payload: res.data.pagination,
        });
      }
    });
  } catch (e) {
    validationErrors(e);
  }
  if (request_status) return return_data;
  else return false;
};

export const riderShiftRemoveAction = (riderShiftId, data) => async (dispatch, getState) => {
  let request_status = false;
  let return_data = [];
  try {
    await riderShiftRemove(riderShiftId, getState().authReducer.token, getState().authReducer.user.id).then((res) => {
      if(res.data.code === 200){
        request_status = true;
        return_data = res.data
      }
    });
  } catch (e) {
    validationErrors(e);
  }
  if (request_status) return return_data;
  else return false;
};

export const RiderReAssignShiftAction = (riderShiftId) => async (dispatch, getState) => {
  let request_status = false;
  let return_data = [];
  try {
    await RiderReAssignShift(riderShiftId, getState().authReducer.token, getState().authReducer.user.id).then((res) => {
      if(res.data.code === 200){
        request_status = true;
        return_data = res.data
      }
    });
  } catch (e) {
    validationErrors(e);
  }
  if (request_status) return return_data;
  else return false;
};


export const getShiftTypesAction = (shiftId, data) => async (dispatch, getState) => {
  let request_status = false;
  let return_data = [];
  try {
    await getShiftTypes(getState().authReducer.token, getState().authReducer.user.id).then((res) => {
      if(res.data.code === 200){
        dispatch({
          type: types.SET_SHIFT_TYPES,
          payload: res.data.data,
        });
      }
    });
  } catch (e) {
    validationErrors(e);
  }
  if (request_status) return return_data;
  else return false;
};
